import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";

export interface ILocations {}

export enum TabsEnum {
    dashboards,
    productionLines,
    clusters,
    users,
    details,
    localserverMetrics,
}

type HashToTabType = {
    [key: string]: TabsEnum;
};

type TabToHashType = {
    [key in TabsEnum]: string;
};

export const HASH_TO_TAB: HashToTabType = {
    [CORPORATE_BACKOFFICE_PATHS.LOCATIONS.HASH_PATHS.DASHBOARDS]: TabsEnum.dashboards,
    [CORPORATE_BACKOFFICE_PATHS.LOCATIONS.HASH_PATHS.PRODUCTION_LINES]: TabsEnum.productionLines,
    [CORPORATE_BACKOFFICE_PATHS.LOCATIONS.HASH_PATHS.CLUSTERS]: TabsEnum.clusters,
    [CORPORATE_BACKOFFICE_PATHS.LOCATIONS.HASH_PATHS.USERS]: TabsEnum.users,
    [CORPORATE_BACKOFFICE_PATHS.LOCATIONS.HASH_PATHS.SETTINGS]: TabsEnum.details,
    [CORPORATE_BACKOFFICE_PATHS.LOCATIONS.HASH_PATHS.LOCAL_SERVER]: TabsEnum.localserverMetrics,
};

export const TAB_TO_HASH: TabToHashType = Object.entries(HASH_TO_TAB).reduce((acc, [hash, tab]) => {
    acc[tab] = hash;
    return acc;
}, {} as TabToHashType);
